<template>
  <!-- The Master Service Agreement as the buyer reads it on Buy IMPROVE:
       a loading state, a retry on failure, then the html in a sandboxed frame
       (no scripts, no same-origin access). Used to review before signing, and
       on request on the payment step. -->
  <div class="contract-frame-wrap">
    <div v-if="loading" class="contract-state">
      <v-progress-circular indeterminate color="#08a0a8" size="36"></v-progress-circular>
      <p>Preparing your agreement</p>
    </div>
    <div v-else-if="error" class="contract-state">
      <p>We could not load your agreement.</p>
      <v-btn text color="#08a0a8" @click="$emit('retry')">Try again</v-btn>
    </div>
    <iframe
      v-else
      class="contract-frame"
      sandbox=""
      :srcdoc="html"
      title="Master Service Agreement"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'AgreementFrame',
  props: {
    html: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* --line and --grey come from the Buy IMPROVE page; the fallbacks are its values. */
.contract-frame-wrap {
  height: 560px;
  border: 1px solid var(--line, #e6ebf1);
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;
  margin-bottom: 22px;
}

.contract-frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #ffffff;
}

.contract-state {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--grey, #6b7280);
  font-size: 14px;
}

.contract-state p {
  margin: 0;
}

@media screen and (max-width: 600px) {
  .contract-frame-wrap {
    height: 440px;
  }
}
</style>
